<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 32 32">
    <g id="Layer_3" data-name="Layer 3">
      <path
        d="M27.311,4H4.689A3.693,3.693,0,0,0,1,7.689V24.311A3.693,3.693,0,0,0,4.689,28H27.311A3.693,3.693,0,0,0,31,24.311V7.689A3.693,3.693,0,0,0,27.311,4ZM4.689,6H27.311A1.691,1.691,0,0,1,29,7.689v.765L16,16.811,3,8.454V7.689A1.691,1.691,0,0,1,4.689,6ZM27.311,26H4.689A1.691,1.691,0,0,1,3,24.311V10.832l12.459,8.009a1,1,0,0,0,1.082,0L29,10.832V24.311A1.691,1.691,0,0,1,27.311,26Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4EnvelopeSvg"
};
</script>
